const createElement = (name_element: string) => {
  const element = document.createElement(name_element)
  return element
}

export const createLinkElement = (url: string, is_blank?: boolean): void => {
  const element = createElement('a') as HTMLAnchorElement
  element.href = url
  if (is_blank) element.target = '_blank'
  element.click()
}
